<template>
    <transition name="fade">
        <div class="modal modal-default">
            <div class="modal__overlay" @click="$emit('close')"></div>
            <div class="small-modal">
                <div class="small-modal__close" @click="$emit('close')">X</div>
                <div class="small-modal__head">
                    <span>Demander le règlement de commissions</span>
                </div>
                <div class="small-modal__body">
                    <div class="small-modal__body__block">
                        <div class="small-modal__body__block--title text-capitalize required">
                            <span>Montant (300 € - {{balances.available}} €)</span>
                        </div>
                        <div class="small-modal__body__block__content">
                            <div class="small-modal__body__block__content--input">
                                <input 
                                    type="number"
                                    v-model.number="amount"
                                    :min="300"
                                    :max="balances.available"
                                    @input="validateAmount"
                                />
                            </div>
                            <div class="small-modal__body__block__content--error" style="font-size:14px;color:red;" v-if="amountError">
                                {{amountError}}
                            </div>
                        </div>
                    </div>
                    <div class="small-modal__body__block">
                        <div class="small-modal__body__block--title text-capitalize">
                            <span>Note</span>
                        </div>
                        <div class="small-modal__body__block__content">
                            <div class="small-modal__body__block__content--input">
                                <textarea v-model="notes" @input="validateNotes"></textarea>
                            </div>
                            <div class="small-modal__body__block__content--error" style="font-size:14px;color:red;" v-if="notesError">
                                {{notesError}}
                            </div>
                        </div>
                    </div>
                </div>
                <div class="small-modal__footer">
                    <div class="small-modal__footer__actions d-flex justify-content-between">
                        <button class="blue-button" @click.prevent="$emit('close')">
                            <span>Annuler</span>
                        </button>
                        <button class="green-button" @click.prevent="submit" :disabled="sending">
                            <span v-if="sending">
                                <svg
                                    width="24" height="24" viewBox="0 0 50 50"
                                    xmlns="http://www.w3.org/2000/svg" aria-label="Loading" role="img">
                                    <circle
                                        cx="25" cy="25" r="20"
                                        fill="none"
                                        stroke="currentColor"
                                        stroke-width="6"
                                        stroke-linecap="round"
                                        stroke-dasharray="90 150"
                                        transform="rotate(-90 25 25)">
                                        <animateTransform
                                            attributeName="transform"
                                            type="rotate"
                                            from="0 25 25"
                                            to="360 25 25"
                                            dur="1s"
                                            repeatCount="indefinite" />
                                    </circle>
                                </svg>
                            </span>
                            <span v-else>Envoyer</span>
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </transition>
</template>

<script>
export default {
    name: 'CommissionsMensuellesDemanderReglementModal',
    props: {
        balances: {
            type: Object,
            required: true
        }
    },
    data() {
        return {
            sending: false,
            amount: null,
            notes: null,
            amountError: null,
            notesError: null
        }
    },
    computed: {
        isClientMonthlyPayment() {
            return this.$store.getters.isClientMonthlyPayment;
        },
        mechanic() {
            return this.$store.getters.getMechanic;
        }
    },
    methods: {
        validateAmount() {
            if (this.amount === '' || this.amount === null) {
                this.amountError = 'Le montant est obligatoire';
                return false;
            }
            const amountNum = parseFloat(this.amount);
            if (isNaN(amountNum)) {
                this.amountError = 'Veuillez entrer un nombre valide';
                return false;
            }
            if (amountNum < 50) {
                this.amountError = `Le montant minimum est de 50 €`;
                return false;
            }
            if (amountNum > this.balances.available) {
                this.amountError = `Le montant ne peut pas dépasser ${this.balances.available} €`;
                return false;
            }
            this.amountError = null;
            return true;
        },
        validateNotes() {
            if (!this.notes || this.notes.trim() === '') {
                this.notesError = null;
                return true;
            }
            
            const maxLength = 500;
            if (this.notes.length > maxLength) {
                this.notesError = `La note ne peut pas dépasser ${maxLength} caractères`;
                return false;
            }
            this.notesError = null;
            return true;
        },
        submit() {
            if (!this.validateAmount() || !this.validateNotes()) {
                return;
            }
            let url = `${this.mechanic.id}/commissions-mensuelles/payment-request`;
            let data = {
                amount: this.amount,
                notes: this.notes
            };
            this.sending = true;
            this.apiPost(url, data)
            .then((response) => {
                this.sending = false;
                if(response.data && response.data.status === 'success') {
                    this.showSuccessNotification("Le règlement a été demandé avec succès.");
                    this.$emit('close');
                    this.$emit('refresh-requests');
                } else if(response.data && response.data.status === 'error') {
                    if(response.data.message && response.data.message.amount) {
                        this.amountError = response.data.message.amount[0];
                    }
                    if(response.data.message && response.data.message.notes) {
                        this.notesError = response.data.message.notes[0];
                    }
                    this.showErrorNotification("Données de formulaire invalides.");
                } else {
                    this.showErrorNotification("Une erreur est survenue.");
                }
            })
            .catch(error => {
                this.showErrorNotification(error);
                this.sending = false;
            });
        },
        resetForm() {
            this.sending = false;
            this.amount = null;
            this.notes = null;
            this.amountError = null;
            this.notesError = null;
        }
    }
}
</script>


// WEBPACK FOOTER //
// src/components/Commissions/CommissionsMensuellesDemanderReglementModal.vue